export const UserDetailsTabsEnum = {
  OVERVIEW: 0,
  ROLES_AND_PERMISSIONS: 1,
  GROUPS: 2,
  ACTIVITY_HISTORY: 3,
};

export default UserDetailsTabsEnum;

